import useGetDetailItem from "@hooks/News/useGetNews";
import formMapper from "@mappers/Modules/news/NewsItem.mapper";
import updateItem from "@services/News/updateNews";
import Modify from "@shared/FormTemplates/Modify";
import validator from "@validators/Modules/news/news.validate";
import { ReactElement } from "react";
import ModifyForm from "./ModifyForm";

const ModifyItem = (): ReactElement => (
  <Modify
    CustomForm={ModifyForm}
    modifyHook={updateItem}
    detailHook={useGetDetailItem}
    validator={validator}
    formMapper={formMapper}
  />
);

export default ModifyItem;
